import HomePage from 'marketing/containers/home';
export { HomePage };
